<div class="toast-stack">
  <div class="toast" *ngFor="let toast of toasts$ | async" [ngClass]="'tone-' + toast.tone">
    <div class="toast-body">
      <p class="toast-title">{{ toast.title }}</p>
      <p class="toast-message" *ngIf="toast.message">{{ toast.message }}</p>
    </div>
    <button type="button" class="toast-close" (click)="dismiss(toast.id)" aria-label="Dismiss">&times;</button>
  </div>
</div>
